import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard {
  constructor(public router: Router) {}

  canActivate() {
    if (AuthService.loggedIn()) {
      this.router.navigate(['/index/usuarios/usuarios']);
      return false;
    }
    return true;
  }
}
